import { useQuery } from "@tanstack/react-query";
import useApi from "../../../../../shared/hooks/useApi";
import type { PatientProfilePatient } from "../../../patientProfileModal.types";

export function usePatientAssociatedCaregivers(patientId: PatientProfilePatient["id"]) {
  const { api } = useApi();

  return useQuery({
    queryKey: ["patientProfileModal", patientId, "caregivers"],
    queryFn: () =>
      api.get("./patient/:patientId/caregivers_associated", {
        path: { patientId },
      }),
  });
}
